import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { ClassListItem } from '@beable/roster-backend-client-v1';
import { getStyles } from './styles';
import dataViewService from '../../services/DataViewService';
import { CircularProgress } from '@mui/material';

interface ClassesTableProps {
  siteId: number;
  courseId: string;
  schoolId: string;
  onClassSelect: any;
}

export default function ClassesTable(props: ClassesTableProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const [isLoading, setIsLoading] = useState(false);
  const [courseClasses, setCourseClasses] = useState<ClassListItem[]>([]);
  const [selectedClass, setSelectedClass] = useState<ClassListItem | undefined>(undefined);

  useEffect(() => {
    const fetchClasses = async () => {
      setIsLoading(true);
      const fetchedCourseClasses = await dataViewService.getClassesForCourse(props.courseId, props.siteId);
      setIsLoading(false);
      if(fetchedCourseClasses) {
        setCourseClasses(fetchedCourseClasses);
      } else {
        setCourseClasses([]);
        alert("Could not get the classes for this course. Please contact support...")
      }
    };

    fetchClasses();
  }, [props.courseId, props.siteId]);

  const handleClassSelect = async (schoolId: string, cls: ClassListItem) => {
    setSelectedClass(cls);
    props.onClassSelect(schoolId, cls.id);
  };

  return (
    <Box sx={styles.courses_root}>
      {isLoading ?
            <Box sx={styles.loaderContainer}>
                <CircularProgress disableShrink />
            </Box> :
            null}
      {!isLoading ?
      <Table size="small" aria-label="classes table">
        <TableHead>
          <TableRow>
            <TableCell>Class</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Users</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {!isLoading && courseClasses && courseClasses.map((cls) => {
              return(<TableRow selected={selectedClass && selectedClass.id === cls.id}
                               key={cls.id} sx={styles.clickable}
                               onClick={() => handleClassSelect(props.schoolId, cls)}>
                  <TableCell>{cls.name}</TableCell>
                  <TableCell>{cls.internalStatus}</TableCell>
                  <TableCell>{cls.numberOfUsers}</TableCell>
              </TableRow>)
          })}
        </TableBody>
      </Table> :
      null}
    </Box>
  );
}
